import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import { useDispatch, useSelector } from "react-redux";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ItemInputCard from "~business/Cards/ItemInputCard";

import { FieldChangeEvent } from "~business/Cards/types";
import { GetAseguradoResponse } from "~api/types";
import { CampoFormulario } from "../../types";

import {
  getAsegurado,
  setAseguradoNombre,
  setAseguradoApellido,
  setAseguradoNumeroDocumento,
  setSubmitting,
} from "../actions";

interface SliceDatosAsegurado {
  nombreAsegurado: CampoFormulario<string | null>;
  apellidoAsegurado: CampoFormulario<string | null>;
  dni: CampoFormulario<string | null>;
  aseguradoFromDocumento: GetAseguradoResponse | null;
}

interface DatosAseguradoCardProps {
  isLoading: boolean;
  isLoadingAsegurado: boolean;
}

const useReduxSelector = () =>
  useSelector<any, SliceDatosAsegurado>((state) => {
    return {
      nombreAsegurado: state.altaPolizaMultiramaReducer.aseguradoNombreSelected,
      apellidoAsegurado:
        state.altaPolizaMultiramaReducer.aseguradoApellidoSelected,
      dni: state.altaPolizaMultiramaReducer.aseguradoNumeroDocumentoSelected,
      aseguradoFromDocumento: state.altaPolizaMultiramaReducer.asegurado,
    };
  });

const title = "Datos del Asegurado";

const DatosAseguradoCard: React.FC<DatosAseguradoCardProps> = ({
  isLoading,
  isLoadingAsegurado,
}) => {
  const dispatch = useDispatch();

  const { nombreAsegurado, apellidoAsegurado, dni, aseguradoFromDocumento } =
    useReduxSelector();

  let timer: ReturnType<typeof setTimeout> | undefined;

  const handleBlurDni = (dni: string) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(getAsegurado(dni));
    }, 200);
    dispatch(setSubmitting(false));
  };

  const handleBlur = () => {
    dispatch(setSubmitting(false));
  };

  const handleChangeNombre = (nombre: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setAseguradoNombre(nombre));
    }, 200);
  };

  const handleChangeApellido = (apellido: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setAseguradoApellido(apellido));
    }, 200);
  };

  const handleChangeDni = (dni: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setAseguradoNumeroDocumento(dni));
    }, 200);
  };

  return (
    <>
      <DetalleCard title={title} IconHeader={VerifiedUserIcon}>
        <ItemInputCard
          id={"dni"}
          isLoading={isLoading}
          label={"DNI"}
          value={dni.value}
          onChange={handleChangeDni}
          onBlur={() => handleBlurDni(dni.value as string)}
          focus={dni.focus}
          required
        />

        {!aseguradoFromDocumento && (
          <>
            <ItemInputCard
              id={"nombreAsegurado"}
              isLoading={isLoadingAsegurado}
              label={"Nombre Titular"}
              value={nombreAsegurado.value}
              onChange={handleChangeNombre}
              onBlur={handleBlur}
              focus={nombreAsegurado.focus}
              required
            />
            <ItemInputCard
              id={"apellido"}
              isLoading={isLoadingAsegurado}
              label={"Apellido Titular"}
              value={apellidoAsegurado.value}
              onChange={handleChangeApellido}
              onBlur={handleBlur}
              focus={apellidoAsegurado.focus}
              required
            />
          </>
        )}
        {aseguradoFromDocumento && (
          <>
            <ItemInputCard
              id={"nombreAsegurado"}
              isLoading={isLoadingAsegurado}
              label={"Nombre Titular"}
              value={nombreAsegurado.value}
              readOnly
            />
            <ItemInputCard
              id={"apellido"}
              isLoading={isLoadingAsegurado}
              label={"Apellido Titular"}
              value={apellidoAsegurado.value}
              readOnly
            />
          </>
        )}
      </DetalleCard>
    </>
  );
};

export default DatosAseguradoCard;
